/* eslint-disable @calm/react-intl/missing-formatted-message */
import Restart16 from '@carbon/icons-react/es/restart/16';
import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { ReactComponent as ExclamationTriangle } from 'assets/svgs/exclamation-triangle.svg';
import { Button } from 'components/atoms/button';
import { EmptyState, EmptyStateContainer } from 'components/atoms/empty-state';
import { BodyShort01 } from 'components/styles';

const Description = styled.div`
  ${BodyShort01};
`;

const RefreshButton = styled(Button)`
  width: fit-content;
`;

const LinkButton = styled(Button)`
  padding: 0 var(--spacing-01) !important;
`;

declare global {
  interface Window {
    fcWidget: any;
  }
}

enum Status {
  Unchecked = 'Unchecked',
  NotRequired = 'NotRequired',
  ScriptTagAdded = 'ScriptTagAdded',
  Loaded = 'Loaded',
  Initialized = 'Initialized',
}

let status: Status = Status.Unchecked;

const initFreshChat = () => {
  if (status !== Status.Loaded) {
    return;
  }
  status = Status.Initialized;
  window.fcWidget.init({
    token: 'd032d723-fcdc-411d-bcc7-ffc0c81b1c4a',
    host: 'https://wchat.freshchat.com',
    config: {
      headerProperty: {
        direction: 'ltr',
        hideChatButton: true,
      },
      cssNames: {
        widget: 'rl-custom-fc-widget',
        open: 'rl-custom-fc-widget--open',
      },
    },
  });
};
const initialize = () => {
  if (status !== Status.Unchecked) {
    return;
  }
  status = Status.ScriptTagAdded;
  const element = document.createElement('script');

  element.id = 'freshchat-js-sdk';
  element.async = true;
  element.onload = () => {
    status = Status.Loaded;
    initFreshChat();
  };
  element.src = 'https://wchat.freshchat.com/js/widget.js';
  document.head.appendChild(element);
};

export const AppCrash = () => {
  const refreshPage = useCallback(() => {
    window.location.reload();
  }, []);

  const openFreshChat = useCallback(() => {
    window.fcWidget.open();
  }, []);

  useEffect(() => {
    if (status === Status.Unchecked) {
      initialize();
      status = Status.NotRequired;
    }
  }, []);

  return (
    <EmptyStateContainer $transparent>
      <EmptyState
        image={<ExclamationTriangle />}
        title="Something went wrong"
        message="There was an error loading this page. Please try refreshing."
        primaryCTA={
          <RefreshButton
            type="primary"
            onClick={refreshPage}
            iconPlacement="right"
            icon={<Restart16 />}
          >
            Refresh
          </RefreshButton>
        }
        secondaryCTA={
          <Description>
            If the issue still persists
            <LinkButton type="link" onClick={openFreshChat}>
              please reach out to us.
            </LinkButton>
          </Description>
        }
      />
    </EmptyStateContainer>
  );
};
